<template>
  <div class="w-full space-y-6">
    <div class="grid grid-cols-10 gap-6">
      <div class="col-span-10">
        <label class="block text-sm font-medium text-gray-700 mb-1">Learning outcomes</label>
        <span class="text-sm text-gray-700">Provide key learning points and knowledge gains</span>
        <div class="relative">
          <QuillEditor
            data-cy="session-learning-outcomes"
            ref="session"
            theme="snow"
            v-model:content="what_you_will_learn"
            @editorChange="changingSessionContent('what_you_will_learn')"
            @textChange="limitCharacters('session')"
            contentType="html"
          />
          <CharacterCount :section="what_you_will_learn" :maxLength="MAX_CHAR_LENGTH" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { QuillEditor } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.prod.css';
import CharacterCount from '../Inputs/CharacterCount.vue';
import { MAX_CHAR_LENGTH } from '@/Utils/vice-constants';

export default {
  name: 'LearningOutcomes',
  components: {
    QuillEditor,
    CharacterCount,
  },
  data() {
    return {
      MAX_CHAR_LENGTH,
      what_you_will_learn: this.$page.props.session
        ? this.$page.props.session.about?.what_you_will_learn
        : '',
    };
  },
  methods: {
    changingSessionContent(type) {
      this.$emit('changeSessionContent', { type, content: this[type] });
    },
    limitCharacters(type) {
      const quill = this.$refs[type].getQuill();
      if (quill.getLength() > MAX_CHAR_LENGTH) {
        quill.deleteText(MAX_CHAR_LENGTH, quill.getLength());
      }
    },
  },
};
</script>

<style>
.ql-container,
.ql-editor {
  min-height: 200px;
}
</style>
